import { adsMidBrownB } from "../utils/ADSColours";

const StreetSurface = [
  {
    id: 1,
    gpText: "Metalled",
    colour: adsMidBrownB,
  },
  {
    id: 2,
    gpText: "Unmetalled",
    colour: adsMidBrownB,
  },
  {
    id: 3,
    gpText: "Mixed",
    colour: adsMidBrownB,
  },
];

export default StreetSurface;
